import React from 'react'
import styled from 'styled-components'
import ShardCard from '@/components/shardLibrary/ShardCard'
import { SHARD_WIDTH, SHARD_GRID_GAP } from '@/config/settings'

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  color: white;
  overflow: hidden;
  flex-grow: 1;
`

const GridContainer = styled.div<{ rowHeight?: number }>`
  width: 100%;
  display: grid;
  margin-top: 10px;
  margin-left: 0px;
  grid-gap: ${SHARD_GRID_GAP}px;
  grid-template-columns: repeat(auto-fit, ${SHARD_WIDTH}px);
  grid-template-rows: ${props => props.rowHeight}px;
  justify-content: center;
  align-items: end;
  max-height: 610px;
`

const Shard = styled.div<{ rowHeight?: number }>`
  width: ${SHARD_WIDTH}px;
  height: ${props => props.rowHeight}px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  color: white;
`

interface ShardItem {
  id: number
  premium?: boolean
  isPublic?: boolean
  imported?: boolean
  [key: string]: any
}

interface ShardsProps {
  shards?: ShardItem[]
  contentRef?: React.Ref<HTMLDivElement>
  rowHeight?: number
  filterMethod?: string
}

const Shards = ({ shards, contentRef, rowHeight, filterMethod }: ShardsProps) => {
  return (
    <Container ref={contentRef as React.Ref<HTMLDivElement>}>
      <GridContainer
        rowHeight={rowHeight}
      >
        {shards?.map(shard => {
          const { id, premium, isPublic, imported } = shard
          const shardType = premium
            ? 'premium'
            : isPublic
              ? 'public'
              : imported
                ? 'community'
                : 'private'

          return (
            <Shard key={`shards_${id}`} rowHeight={rowHeight}>
              <ShardCard { ...shard } condensed={filterMethod === 'list'} type={shardType} />
            </Shard>
          )
        })}
      </GridContainer>
    </Container>
  )
}

export default Shards
